/* eslint-disable import/prefer-default-export */
export const ApiBaseUrl = 'https://localhost:5000';
export const grey = '#f2f2f2';
export const secondary = '#D98C5F';
export const primary = '#6B8E72'; // Green
export const warmGold = '#E3B778'; // New Gold Accent
export const warmerGold = '#C28A45'; // Darker Gold Accent
export const darkGold = '#C28A45';
export const favoritedColor = '#FF6347'; // Tomato Red
export const cancelColor = '#C87450';
export const unfavoritedColor = '#8C7051';
export const white = '#FFFFFF';
export const cardBackground = '#FAF3E0';
export const loadingBackdropColor = '#fff';
export const whiteBackground = '#F8F5EC'; // Off-white
export const blackText = '#2F2F2F'; // Dark Gray
export const espressoBrown = '#5B4A32';
export const searchText = '#5F5B52';
export const featureItemText = '#777';
export const straightFont = 'Montserrat, sans-serif';
export const cursiveFont = 'Dancing Script';
